// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-slide-toggle {
  margin: 0;
}
.modal-body .form-row {
  margin: 8px 0;
}
.modal-header {
  background-color: #0f1a35;
  color: white !important;
}
.modal-header .modal-title {
  font-size: 20px !important;
  font-weight: 600;
}
.modal-header .close {
  color: red;
  text-shadow: none;
  opacity: 1;
  font-size: 26px;
  padding: 0 !important;
  margin: 0 !important;
  box-shadow: none;
  background: transparent;
  right: 20px;
  position: absolute;
}
.modal-footer {
  padding: 2px !important;
}
.bigAssModal .modal-dialog {
  max-width: 90% !important;
}
.bubble {
  color: white;
  height: 40x !important;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Font Awesome 5 Pro', sans-serif;
  font-weight: 200 !important;
  font-size: 14px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  min-width: -moz-fit-content;
  min-width: fit-content;
}
.riq-slider-container {
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 80% !important;
  display: flex;
  height: 40px !important;
}
.riq-text-container {
  margin-left: 12.5%;
  margin-right: 10%;
  width: 80%;
  margin-top: 40px;
}
.end-left {
  border-radius: 25px 0 0 25px;
}
.end-right {
  border-radius: 0 25px 25px 0;
}
.cell-green {
  background-color: #54a54e;
}
.cell-yellow {
  background-color: #e2b94f;
}
.cell-orange {
  background-color: #d88949;
}
.cell-red {
  background-color: #ce6161;
}
.slider-node {
  color: white;
  height: 45px !important;
}
.instructions {
  padding: 30px 15px;
  text-align: center;
}
.load-bubble {
  animation-duration: 0.095s;
  animation-name: grow-right;
  animation-timing-function: linear;
  transform-origin: center;
}
@keyframes grow-right {
  from {
    transform: scaleX(95%);
  }
  to {
    transform: scaleX(100%);
  }
}
.slider-value {
  margin-left: 5px;
  margin-right: 5px;
}
.rdinput {
  max-width: 60px;
  font-weight: bold;
}
.invalid-feedback {
  width: 95% !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/ngb-modals.less","webpack://./src/app/shared-components-module/riq-slider-v2/riq-slider-v2.component.less"],"names":[],"mappings":"AAEA;EACE,SAAA;ACDF;ADGA;EACI,aAAA;ACDJ;ADIA;EACI,yBAAA;EACA,uBAAA;ACFJ;ADAA;EAKO,0BAAA;EACA,gBAAA;ACFP;ADJA;EASO,UAAA;EACC,iBAAA;EACA,UAAA;EACD,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;ACFP;ADMA;EACI,uBAAA;ACJJ;ADOA;EACI,yBAAA;ACLJ;AA5BA;EAKI,YAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,6CAAA;EACA,2BAAA;EACA,eAAA;EAEA,4CAAA;EACA,2BAAA;EAAA,sBAAA;AAyBJ;AAtBA;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;AAwBJ;AApBA;EACI,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;AAsBJ;AAnBA;EACI,4BAAA;AAqBJ;AAnBA;EACI,4BAAA;AAqBJ;AAlBA;EACI,yBAAA;AAoBJ;AAjBA;EACI,yBAAA;AAmBJ;AAhBA;EACI,yBAAA;AAkBJ;AAfA;EACI,yBAAA;AAiBJ;AAdA;EACI,YAAA;EACA,uBAAA;AAgBJ;AAbA;EACI,kBAAA;EACA,kBAAA;AAeJ;AAXA;EACI,0BAAA;EACA,0BAAA;EACA,iCAAA;EACA,wBAAA;AAaJ;AAVA;EACI;IACE,sBAAA;EAYJ;EATE;IACE,uBAAA;EAWJ;AACF;AARA;EACI,gBAAA;EACA,iBAAA;AAUJ;AAPA;EACI,eAAA;EACA,iBAAA;AASJ;AANA;EACI,qBAAA;AAQJ","sourcesContent":["@import (reference) url('../styles.less');\n\nmat-slide-toggle {\n  margin: 0;\n}\n.modal-body .form-row{\n    margin: 8px 0;\n}\n\n.modal-header{\n    background-color: #0f1a35;\n    color: white !important;\n    \n    .modal-title{\n       font-size: 20px !important;\n       font-weight: 600;\n    };\n    .close{\n       color: red;\n        text-shadow: none;\n        opacity: 1;\n       font-size: 26px;\n       padding: 0 !important;\n       margin : 0 !important;\n       box-shadow: none;\n       background: transparent;\n       right: 20px;\n       position: absolute;\n    }\n}\n\n.modal-footer{\n    padding: 2px !important;\n}\n\n.bigAssModal .modal-dialog{\n    max-width: 90% !important;\n}","@import url(../../../styles.less);\n@import '../../../assets/ngb-modals.less';\n\n.bubble {\n    // padding-left: 30px;\n    // padding-right: 30px;\n    // padding-top: 10px;\n    // padding-bottom: 10px;\n    color: white;\n    height: 40x !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-family: 'Font Awesome 5 Pro', sans-serif;\n    font-weight: 200 !important;\n    font-size: 14px;  \n    // animation: 3s linear 1s slide-in;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n    min-width: fit-content;\n}\n\n.riq-slider-container {\n    margin-left: 10%;\n    margin-right: 10%;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    width: 80% !important;\n    display: flex;\n    height: 40px !important;\n    \n}\n\n.riq-text-container {\n    margin-left: 12.5%;\n    margin-right: 10%;\n    width: 80%;\n    margin-top: 40px;\n}\n\n.end-left {\n    border-radius: 25px 0 0 25px;\n}\n.end-right {\n    border-radius: 0 25px 25px 0;\n}\n\n.cell-green {\n    background-color: @green;\n}\n\n.cell-yellow {\n    background-color: @yellow;\n}\n\n.cell-orange {\n    background-color: @orange;\n}\n\n.cell-red {\n    background-color: @red;\n}\n\n.slider-node {\n    color: white;\n    height: 45px !important;\n}\n\n.instructions {\n    padding: 30px 15px;\n    text-align: center;\n  }\n\n\n.load-bubble {\n    animation-duration: .095s;\n    animation-name: grow-right;\n    animation-timing-function: linear;\n    transform-origin: center;\n}\n\n@keyframes grow-right {\n    from {\n      transform: scaleX(95%);\n    }\n  \n    to {\n      transform: scaleX(100%);\n    }\n  }\n  \n.slider-value {\n    margin-left: 5px; \n    margin-right: 5px;\n}\n\n.rdinput {\n    max-width: 60px;\n    font-weight: bold;\n}\n\n.invalid-feedback {\n    width: 95% !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
